<template>
  <div id="app" v-if="isRouterActive">
    <AlertNotification :show="alertShow" />
    <!-- <nprogress-container></nprogress-container> -->
    <router-view></router-view>
  </div>
</template>

<script>
// import NprogressContainer from 'vue-nprogress/src/NprogressContainer'
import AlertNotification from '@/components/common/AlertNotification'
import { toggleClass } from './utils'
import { mapState } from 'vuex'

export default {
  name: 'app',
  components: {
    // NprogressContainer,
    AlertNotification,
  },
  computed: {
    ...mapState({
      alertShow: (state) => state.common.alertshow,
      user: (state) => state.common.user,
      themeColor: (state) => state.common.themeColor,
    }),
  },
  beforeMount() {
    window.BMAP_OFFLINE_SERVER = this.user.mapTileUrl //在线瓦片
  },
  mounted() {
    toggleClass(document.body, 'pace-done top-navigation theme-darkblue')
  },
  watch: {
    themeColor(val) {
      toggleClass(document.body, 'pace-done top-navigation theme-darkblue')
      this.themeReload() // 重新加载为切换echarts字段
      $('.modal-backdrop').remove()
    },
  },
  data() {
    return {
      isRouterActive: true,
    }
  },
  methods: {
    themeReload() {
      this.isRouterActive = false
      this.$nextTick(() => {
        this.isRouterActive = true
      })
    },
  },
}
</script>
<style lang="less">
#app {
  height: 100%;
  overflow: hidden;
  background-size: cover;
}
.anchorBL {
  display: none;
}
</style>
